import { render } from "./Suppliers.vue?vue&type=template&id=6ac3f2c2&scoped=true"
import script from "./Suppliers.vue?vue&type=script&lang=ts"
export * from "./Suppliers.vue?vue&type=script&lang=ts"

import "./Suppliers.vue?vue&type=style&index=0&id=6ac3f2c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ac3f2c2"

export default script